import React from 'react';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { isDate, format } from 'date-fns';

import './style.scss';

const ParagraphHighlight = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const subtitle = entity.getIn(['field_subtitle', 0, 'value']);
  const body = entity.getIn(['field_plain_body', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const imageUrl = entity.getIn(['field_media_image', 0, 'styles', 'paragraph_image'], entity.getIn(['field_media_image', 0, 'source']));
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');
  const highlightCaption = entity.getIn(['field_caption', 0, 'value'], '');
  const date = entity.getIn(['field_date', 0, 'value'], null);
  const dateObject = date ? new Date(date) : null;

  return (
    // no Paragraph class because this paragraph is used only inside ParagraphHighlighted
    <div className="Paragraph ParagraphHighlight">

      {highlightCaption && (
        <div className="ParagraphHighlight__caption row">
          {highlightCaption}
        </div>
      )}

      <div className="ParagraphHighlight__inner">
        {imageUrl && (
          <div className="ParagraphHighlight__image__wrapper">
            <Image
              className="ParagraphHighlight__image"
              src={imageUrl}
              alt={imageAlt}
            />
          </div>
        )}

        <div className="ParagraphHighlight__text__wrapper">
          <div>
            {isDate(dateObject) && (
              <div className="ParagrapHighlighted__highlightedItems__date">
                {format(dateObject, 'dd-MM-yy')}
              </div>
            )}

            <h3 className="ParagraphHighlight__title"><CoreLink className="teaser-link" to={linkUri}>{title}</CoreLink></h3>
            {subtitle && (<p className="ParagraphHighlight__subtitle">{subtitle}</p>)}
            {body && (<div className="ParagraphHighlight__body">{body}</div>)}
          </div>
          {linkUri && linkTitle && (
            <CoreLink className="ParagraphHighlight__link icon-after icon-chevron-right" to={linkUri}>{linkTitle}</CoreLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParagraphHighlight;
